<template>
  <div class="container">
    <ListPanel :portal="portal"/>
  </div>
</template>

<script>
import ListPanel from '../../../../../components/Administration/MailingLists/Panels/List'

export default {
  components: {ListPanel},

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: {
    portal: {
      required: true
    }
  }
}
</script>
